import Vue from 'vue'
import VueRouter from 'vue-router'
import $store from '@/store/index'
import $msg from '@/utils/message.js'

import login from "@/views/login.vue"


Vue.use(VueRouter)

const routes = [
		{ name: 'login', path: '/login', component: login},
		{ name: 'home', path: '/home', component: ()=> import('@/views/home.vue'),
		children: [
			{ name: '个人中心', path: '/userCenter/userCenter', component: ()=> import('@/views/userCenter/userCenter.vue')},
			{ name: '事件配置', path: '/design/eventSet/**', component: ()=> import('@/views/design/eventSet.vue')}
		]},
		{ name: 'designapiFile', path: '/design/apiFile', component: ()=> import('@/views/design/apiFile.vue')}
	]

const router = new VueRouter({ mode: 'history', routes })


// 过滤路由信息
function filterRouterList(menuList){
	let routerList = []
	menuList.forEach(v => {
		if(v.type != 1 && v.path) routerList.push({ 
			name: v.name, 
			icon: v.icon, 
			path: v.path, component: v.component, 
			type: v.type,
			componentType: v.componentType,
			openType: v.openType
	   })
		if(v.children && v.children.length > 0){
			let newList = filterRouterList(v.children)
			if(newList.length > 0) routerList = [...routerList, ...newList]
		}
	})
	return routerList
}



function createCustomComponent (name, component) {
  return {
    name,
    data () {
      return { component: null }
    },
    async created () {
      if (component instanceof Promise) {
        try {
          const module = await component
          this.component = module?.default
        } catch (error) {
          console.error(`can not resolve component ${name}, error:`, error)
        }

        return
      }
      this.component = component
    },
    render (h) {
      return this.component ? h(this.component) : null
    },
  }
}




// 生成路由
function generateRouterList(routerList) {
	let pageInRouterList = []
	let pageOutRouterList = []
	routerList.forEach(v => {
		let routeName = v.path.replaceAll('/','')
		let route = {
			name: routeName,
			path: v.path,
			meta: {icon: v.icon, name: v.name, type: v.type, componentType: v.componentType, openType: v.openType}
		}
		if(v.componentType == 2){
			route.component = createCustomComponent(routeName, import('@/views/common/commonPage.vue'))
		}else route.component = () => import('@/views' + v.component +'.vue')
		if(!v.openType || v.openType == 1) pageInRouterList.push(route)
		else pageOutRouterList.push(route)
	})
	return {pageInRouterList, pageOutRouterList}
}

// 鉴权 查看当前访问路径是否存在路由信息

function isHaveRoute(routerList, path){
	let whiteList = ['/userCenter/userCenter','/design/eventSet', '/assets/images']
	let index1 = whiteList.findIndex(v => {
		let nowPath = path.substr(0,v.length)
		return nowPath == v
	})
	if(index1 > -1) return true
	let index2 = routerList.findIndex(v => v.path == path)
	return index2 > -1
}



// 挂载路由导航守卫
router.beforeEach((to, from, next) => {	
	  let isLoadRoute = $store.state.home.isLoadRoute
	  let menuList = [{name: '首页',icon: 'el-icon-s-home',path: '/index',componentType: 1,component: '/index/index',type: 2}]
	  if(sessionStorage.getItem('menuList')) menuList = JSON.parse(sessionStorage.getItem('menuList'))
	  let token = localStorage.getItem('token')
	  let routerList = filterRouterList(menuList)
	  if (to.path == '/login' || to.path == '/design/apiFile') next()
	  else if (!token) {
	    next({path: "/login"})
		if(to.path != '/') $msg.error('请先登录')
	  }else if (to.path == '/' || to.path == '' || to.path == '/home') {
	    next({path: "/index"})
	  }else if (!isLoadRoute) {  // 如果路由信息未加载，就初始化路由信息
		  let newRoutes = router.options.routes
		  let {pageInRouterList, pageOutRouterList} = generateRouterList(routerList)
		  newRoutes[1].children = [...newRoutes[1].children, ...pageInRouterList]
		  newRoutes = [...newRoutes, ...pageOutRouterList]
		  router.addRoutes(newRoutes)
		  $store.commit('setIsLoadRoute')
		  next({path: to.path})
	  } 
	  else if (!isHaveRoute(routerList, to.path)) {
		  next({path: from.path})
		  $msg.error('你访问的资源不存在')
	  }
	  else next()
})

export default router
